













import { Component, Vue, Model, Watch } from 'nuxt-property-decorator'
import vClickOutside from 'v-click-outside'

Vue.use(vClickOutside)

@Component
export default class ComponentDropdown extends Vue {
  @Model('change', { default: false, type: Boolean }) readonly value!: boolean

  private isOpened = false

  private on = {}

  @Watch('isOpen')
  private isOpenHandler(val: boolean) {
    if (val) {
      setTimeout(() => {
        this.isOpened = true
      }, 500)
    }
  }

  private close() {
    if (this.isOpened) {
      this.$emit('change', false)
      this.isOpened = false
    }
  }
}
